export { deferred } from '@qunhe/egs-lib';
export type { Deferred } from '@qunhe/egs-lib';
